module.exports = __webpack_public_path__ + "static/bg2-7f844e52e18951bbba454ad3481db80f.png";